import React, { useState } from "react";
import Appointments from "../../assets/images/icons/user-profile/Appointments.svg";
import CarePlans from "../../assets/images/icons/user-profile/CarePlans.svg";
import ConsentCapacity from "../../assets/images/icons/user-profile/ConsentCapacity.svg";
import CurrentHealthIssues from "../../assets/images/icons/user-profile/CurrentHealthIssues.svg";
import documents from "../../assets/images/icons/user-profile/documents.svg";
import eMAR from "../../assets/images/icons/user-profile/eMAR.svg";
// import LifeHistoryGoals from "../../assets/images/icons/user-profile/LifeHistoryGoals.svg";
import eMARSettings from "../../assets/images/icons/eMARSettings.svg";
import DeviceManagement from "../../assets/images/icons/DeviceManagement.svg";
import AccessSettings from "../../assets/images/icons/AccessSettings.svg";
import CommunicationSettings from "../../assets/images/icons/CommunicationSettings.svg";
import OneTimeCodeSettingsImage from "../../assets/images/icons/OneTimeCodeSettings.svg";
import passwordIcon from "../../assets/images/icons/passwordIcon.svg";


import RiskAssessments from "../../assets/images/icons/careplan-options/RiskAssessments.png";
import PersonalCare from "../../assets/images/icons/careplan-options/PersonalCare.svg";
import RecordanIncident from "../../assets/images/icons/careplan-options/RecordanIncident.svg";
import PatientReview from "../../assets/images/icons/careplan-options/PatientReview.svg";
import { useNavigate } from "react-router-dom";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import ServiceUsersOptionsBlocks from "../../components/user-detail/ServiceUsersOptionsBlocks";
import Layout from "../../components/layouts/Layout";
import Modal from "react-bootstrap/Modal";
import OneTimeCodeSettings from "./one-time-code/OneTimeCodeSettings";
import CommunicationGroupSettings from "./communication_settings/CommunicationGroupSettings";
import PasswordChange from "./password_change/PasswordChange";
function AdminSettings() {
    const navigate = useNavigate();
    const handleRowClickAdminSettings = (url) => {
        navigate(url);
    };

    const [showOneTimeSettings, setShowOneTimeSettings] = useState(false);
    const subModalOneTimeSettings = () => {
        setShowOneTimeSettings(!showOneTimeSettings);
    };

    const [showPasswordChange, setPasswordChange] = useState(false);
    const subModalPasswordChangeModal = () => {
        setPasswordChange(!showPasswordChange);
    };

    const [showCommunicationSettings, setCommunicationSettings] = useState(false);
    const subModalCommunicationSettings = () => {
        setCommunicationSettings(!showCommunicationSettings);
    };
    return (
        <>
            <Layout pageTitleText="Settings">
                <div className="scheduleBlocks careplanOptions">
                    <div className="row">
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={passwordIcon}
                                    heading={"Password Change"}
                                    linkedComponent={() => {
                                        subModalPasswordChangeModal();
                                    }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={OneTimeCodeSettingsImage}
                                    heading={"One Time Code Settings"}
                                    linkedComponent={() => {
                                        subModalOneTimeSettings();
                                    }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={AccessSettings}
                                    heading={"Access Settings"}
                                    linkedComponent={() => { handleRowClickAdminSettings("/advanced") }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={CommunicationSettings}
                                    heading={"Communication Settings"}
                                    linkedComponent={() => {
                                        subModalCommunicationSettings();
                                    }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={DeviceManagement}
                                    heading={"Device Management"}
                                    linkedComponent={() => { handleRowClickAdminSettings("/device-management") }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={eMARSettings}
                                    heading={"eMAR Settings"}
                                    linkedComponent={() => { handleRowClickAdminSettings("/emar-settings") }} />
                            </div>
                        </PermissionWrapper>
                    </div>
                </div>
            </Layout>

            <PermissionWrapper title="Super Admin" action="view">

                <Modal
                    show={showOneTimeSettings}
                    onHide={subModalOneTimeSettings}
                    className="ftcModalPopup medicineInventoryStock"
                    size="md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>One Time Code Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="rosterPopup">
                        <OneTimeCodeSettings subModalOneTimeSettings={subModalOneTimeSettings} />
                    </Modal.Body>
                </Modal>
            </PermissionWrapper>

            <PermissionWrapper title="Super Admin" action="view">

                <Modal
                    show={showCommunicationSettings}
                    onHide={subModalCommunicationSettings}
                    className="ftcModalPopup medicineInventoryStock"
                    size="md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Communication Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="rosterPopup">
                        <CommunicationGroupSettings subModalCommunicationSettings={subModalCommunicationSettings} />
                    </Modal.Body>
                </Modal>
            </PermissionWrapper>


            <PermissionWrapper title="Super Admin" action="view">

                <Modal
                    show={showPasswordChange}
                    onHide={subModalPasswordChangeModal}
                    className="ftcModalPopup medicineInventoryStock"
                    size="md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Change Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="rosterPopup">
                        <PasswordChange subModalPasswordChangeModal={subModalPasswordChangeModal} />
                    </Modal.Body>
                </Modal>
            </PermissionWrapper>
        </>
    )
}

export default AdminSettings